import { useEffect } from "react";
import { ENV } from "../../enviormentVariables";

export default function Analytics() {
  useEffect(() => {
    if (ENV !== "dev") {
      // Check if already added
      if (!document.querySelector('script[src="https://www.googletagmanager.com/gtag/js?id=G-7DVYF6ZK81"]')) {
        // Add GA script
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-7DVYF6ZK81";
        document.head.appendChild(script);

        // Add inline gtag config script
        const inlineScript = document.createElement("script");
        inlineScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){ dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', 'G-7DVYF6ZK81');
        `;
        document.head.appendChild(inlineScript);
      }
    }
  }, []);

  return null;
}
